export enum CrewConstants {
  SET_SHIFT = 'crew/SET_SHIFT',
  SET_BASE = 'crew/SET_BASE',
  SET_STAFFING_LEVEL = 'crew/SET_STAFFING_LEVEL',
  SET_VEHICLE = 'crew/SET_VEHICLE',
  SET_PRIMARY_MONITOR = 'crew/SET_PRIMARY_MONITOR',
  SET_NAME = 'crew/SET_NAME',
  SET_CERTIFICATION_LEVEL = 'crew/SET_CERTIFICATION_LEVEL',
  SET_ROLE = 'crew/SET_ROLE',
  SET_ROLE_PNNV = 'crew/SET_ROLE_PNNV',
  SET_PRECEPTOR_STUDENT = 'crew/SET_PRECEPTOR_STUDENT',
  ON_ADD_CREW_MEMBER = 'crew/ON_ADD_CREW_MEMBER',
  SET_CREW_LIST = 'crew/SET_CREW_LIST',
  ADD_CREW_MEMBER_LIMIT = 24,
  MIN_NO_OF_CREW_MEMBERS_DEL = 1,
  SAVE_CREW_LIST_REQUEST = 'crew/SAVE_CREW_LIST_REQUEST',
  SET_CREW_LIST_DATA = 'crew/SET_CREW_LIST_DATA',
  SET_SHIFT_OPTIONS = 'crew/SET_SHIFT_OPTIONS',
  SET_BASE_OPTIONS = 'crew/SET_BASE_OPTIONS',
  SET_STAFFING_LEVEL_OPTIONS = 'crew/SET_STAFFING_LEVEL_OPTIONS',
  SET_ROLE_OPTIONS = 'crew/SET_ROLE_OPTIONS',
  SET_PRECEPTOR_STUDENT_OPTIONS = 'crew/SET_PRECEPTOR_STUDENT_OPTIONS',
  SET_VEHICLE_OPTIONS = 'crew/SET_VEHICLE_OPTIONS',
  SET_REGISTRATION_TAIL_NUMBER = 'crew/SET_REGISTRATION_TAIL_NUMBER',
  SET_REGISTRATION_TAIL_NUMBER_OPTIONS = 'crew/SET_REGISTRATION_TAIL_NUMBER_OPTIONS',
  SET_UNIT_EQUIPMENT = 'crew/SET_UNIT_EQUIPMENT',
  SET_UNIT_EQUIPMENT_OPTIONS = 'crew/SET_UNIT_EQUIPMENT_OPTIONS',
  SET_PRIMARY_MONITOR_OPTIONS = 'crew/SET_PRIMARY_MONITOR_OPTIONS',
  CHECK_CREW_LIST = 'crew/CHECK_CREW_LIST',
  SET_PCR_CREW = 'crew/SET_PCR_CREW',
  RESET_SHIFT_STARTUP = 'crew/RESET_SHIFT_STARTUP',
  SET_PERSIST_SHIFT_STARTUP = 'crew/SET_PERSIST_SHIFT_STARTUP',
  GET_PERSIST_SHIFT_STARTUP = 'crew/GET_PERSIST_SHIFT_STARTUP',
  SET_CREW_LICENSURES_OPTIONS = 'crew/SET_CREW_LICENSURES_OPTIONS',
}
